<template>
	<div>
		<div v-if="isloading" class="text-center">
			<circular-loader />
		</div>
		<vs-table v-else :data="logs" class="mt-4">
			<template slot="thead">
				<vs-th class="bgcolor white-txt" style="padding-left: 12px">DATE</vs-th>
				<vs-th class="bgcolor white-txt"
					><div style="text-align: center; width: 100%">UTILISATEUR</div></vs-th
				>
				<vs-th class="bgcolor white-txt" style="padding-left: 0px"
					>ACTION</vs-th
				>
				<vs-th class="bgcolor white-txt" style="padding-left: 0px"
					>PRESTATION/CONTRAT</vs-th
				>
				<vs-th class="bgcolor white-txt" style="padding-left: 0px"
					>DÉTAIL</vs-th
				>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(row, index) in data.slice(0, lastPage)">
					<vs-td
						><div style="padding-left: 11px">
							{{
								row.date.substr(0, 6) +
								row.date.substr(8, 2) +
								" - " +
								row.date.substr(11, 5)
							}}
						</div></vs-td
					>
					<vs-td style="padding: 5px !important">
						<vx-tooltip
							:text="
								row.user_name != ' ' ? row.user_name : 'Action automatique'
							"
							position="top"
							style="text-align: center"
						>
							<vs-avatar
								style="border: 1px solid #08b0b9; vertical-align: middle"
								:text="
									row.user_name != ' ' ? row.user_name : 'Action automatique'
								"
								:src="getCollaboratorAvatar(row.users_id)"
							/>
						</vx-tooltip>
					</vs-td>
					<vs-td>{{
						row.action_id ? actionIdNames[row.action_id] : actionIdNames[0]
					}}</vs-td>
					<vs-td>{{ row.mission_name }}</vs-td>
					<vs-td>{{ row.comment }}</vs-td>
				</vs-tr>
				<vs-tr>
					<vs-td colspan="5" class="text-center">
						<vs-button
							color="primary"
							@click="addPage"
							:key="lastPage"
							type="border"
							v-if="lastPage < logs.length"
							style="border-radius: 1px 6px 6px 6px; height: 32px"
							>Voir plus</vs-button
						>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import CircularLoader from "../widgets/loader/CircularLoader.vue";

export default {
	name: "ActionHistoryTable",
	components: { CircularLoader },
	props: {
		contract_id: Number,
		missionExisting: Array,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			logs: [],
			fullname: "",
			missionList: [],
			lastPage: 10,
			actionIdNames: [
				"Ajout",
				"Modification",
				"Suppression",
				"Alerte Commercial",
			],
			isloading: false,
		};
	},
	created() {
		/*
		 * this.getAllCollaborators()
		 * this.getAllCollaboratorsAvatar()
		 */
		this.getAllContractsLog();
	},
	watch: {
		missionExisting: {
			deep: true,
			handler(data) {
				this.missionList = [...data];
				for (let i = 0; i < this.missionList.length; i++) {
					this.missionList[i]["number"] = i + 1;
				}
				this.getAllContractsLog();
			},
		},
		logs: function () {
			this.lastPage = 10;
		},
	},
	methods: {
		addPage() {
			this.lastPage += 5;
		},
		subPage() {
			this.lastPage -= 5;
		},
		getDate(date) {
			// //console.log("???",this.missionExisting)
			return (
				date.substr(8, 2) +
				"/" +
				date.substr(5, 2) +
				"/" +
				date.substr(0, 4) +
				" " +
				date.substr(11, 5)
			);
		},
		getName(userId) {
			/*
			 * return new Promise((resolve, reject) => {
			 *   this.$http.get(this.apiUrl + "users/get/" + userId)
			 *   .then(result => {
			 *       this.fullname = result.data[0].firstname.replace(/^\S/, s => s.toUpperCase()) + " " + result.data[0].lastname.toUpperCase()
			 *       resolve(this.fullname)
			 *   })
			 *   .catch(e => {
			 *     reject(e)
			 *   })
			 * })
			 */
			let foundUser = this.allCollaborators.findIndex(
				(row) => row.id == userId
			);
			if (foundUser >= 0) {
				return (
					this.allCollaborators[foundUser].firstname.replace(/^\S/, (s) =>
						s.toUpperCase()
					) +
					" " +
					this.allCollaborators[foundUser].lastname.toUpperCase()
				);
			} else {
				return " ";
			}
		},
		getAction(actionId) {
			if (actionId == 0) return "Ajout";
			if (actionId == 1) return "Modification";
			if (actionId == 2) return "Suppression";
			if (actionId == 4) return "Alerte Commercial";
		},
		getCollaboratorAvatar(userId) {
			if (userId) {
				let foundAvatar = this.allCollaboratorsAvatar.find(
					(avatar) => avatar.id == userId
				);
				if (foundAvatar) return foundAvatar.avatar;
				else return null;
			} else return "task_default.png";
		},
		getMission(missionId, logs) {
			if (missionId == null) return "Contrat";
			let check = false;
			let num = "x";
			for (let i = 0; i < this.missionList.length; i++) {
				if (this.missionList[i].id == missionId) {
					check = true;
					num = this.missionList[i]["number"];
				}
			}
			if (check == true) return "Prestation n°" + num;

			if (check == false) {
				let foundProduct = logs.find(
					(log) => log.mission_id == missionId && log.action_id == 2
				);
				return `Prestation ${foundProduct ? foundProduct.comment : ""}`;
			}
		},
		async getAllContractsLog() {
			return new Promise((resolve, reject) => {
				this.isloading = true;
				try {
					this.missionList = [...this.missionExisting];

					for (let i = 0; i < this.missionList.length; i++) {
						this.missionList[i]["number"] = i + 1;
					}

					this.$http
						.get(this.apiUrl + "logger/contract/all/" + this.contract_id)
						.then(async (result) => {
							let logs = result.data;
							for (let row of logs) {
								row.user_name = row.users_id ? this.getName(row.users_id) : " ";
								row.mission_name = row.mission_id
									? this.getMission(row.mission_id, result.data)
									: row.order_id
									? "Commande"
									: "Contract";
								row.date = this.getDate(row.timestamp);
							}
							this.logs = logs;
							this.isloading = false;
							resolve(result.data);
						});
				} catch (e) {
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur s'est produite lors de la récupération des logs",
						color: "danger",
					});
					this.isloading = false;
					reject(e);
				}
			});
		},
	},
};
</script>

<style scoped>
</style>
